import {useLayoutEffect as $3vSAe$useLayoutEffect} from "react-aria/private/utils/useLayoutEffect";
import {useState as $3vSAe$useState} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $f57c7d8d50bdc255$export$e52e2242b6d0f1d4(query, ref) {
    let [hasChild, setHasChild] = (0, $3vSAe$useState)(true);
    (0, $3vSAe$useLayoutEffect)(()=>{
        setHasChild(!!(ref.current && ref.current.querySelector(query)));
    }, [
        setHasChild,
        query,
        ref
    ]);
    return hasChild;
}


export {$f57c7d8d50bdc255$export$e52e2242b6d0f1d4 as useHasChild};
//# sourceMappingURL=useHasChild.mjs.map
